import { t } from '@lingui/core/macro';

import Stack from '@/design_system/Stack';
import { Entity } from '@/models/entity';

import { BrandToWorkshop } from '../../components/BrandToWorkshop';
import { CardSection } from '../../components/CardSection';
import { CustomFields } from '../../components/CustomFields';

export const WorkshopSection = ({ entity }: { entity: Entity }) => {
  const workshopFields = [
    {
      label: t({ id: 'settings.workshop-info.opening-hours', message: 'Non digitalized' }),
      value: entity.workshopConfig?.nonDigitalized
        ? t({ id: '_general.yes', message: 'Yes' })
        : t({ id: '_general.no', message: 'No' }),
    },
  ];

  return (
    <Stack gap="1em">
      <CardSection
        title={t({ id: 'settings.workshop-info.label', message: 'Workshop Informations' })}
        fields={workshopFields}
      />
      <BrandToWorkshop workshopId={entity.id} />
      <CustomFields entity={entity} trait="workshop" />
    </Stack>
  );
};
